// extracted by mini-css-extract-plugin
export default {"container":"x2-z","heading":"y2-z","links":"z2-z","copy":"A2-z","subCopy":"B2-z","linksLeft":"C2-z","linksCenter":"D2-z","linksRight":"E2-z","link":"F2-z","onlyLink":"G2-z"};